// extracted by mini-css-extract-plugin
module.exports = {"image":"challenges_image__Ffakg","card":"challenges_card__2tmcz","title":"challenges_title__1FoDk"};